import axios from 'axios';

const csrfToken = document.head.querySelector('meta[name=csrf-token]').getAttribute('content');

export default axios.create({
    baseURL: `${process.env.APP_DOMAIN}/api`,
    headers: {
        'X-CSRF-TOKEN': csrfToken
    }
});
